// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-box {
  width: 40px;
  padding: 20px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  left: 0;
  z-index: 900;
}
.switch-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
}
.sticky-container {
  display: flex;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 1;
  background-color: #fff;
  /* Add any additional styling you need here */
}

/* Styles for the month number */
.month-number {
  font-size: 20px; /* Adjust the font size as needed */
  font-weight: bold;
}

.week-table {
  border-collapse: collapse;
  width: 100%;
}

.week-table th,
.week-table td {
  border: 1px solid #ccc;
  padding: 4px;
  text-align: center;
  min-width: 110px;
}
.week-table th {
  background-color: #f0f0f0;
  font-weight: bold;
  width: 110px;
  height: 10px;
}

.day-header {
  font-size: 16px;
}

.time-column {
  font-size: 16px;
  position: sticky;
  left: 82px;
  border: 1px solid #ccc;
  top: 0;
  background-color: white;
  z-index: 1;
}

/* .cell {
  background-color: #ffffff;
} */

.add-event-cell {
  text-align: center;
}

.add-event-button button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 6px 12px;
  cursor: pointer;
}

.add-event-button button:hover {
  background-color: #45a049;
}

.custom-modal {
  width: 60%;
  max-width: 400px;
  margin: 0 auto;
}

.modal-content {
  padding: 20px;
}

.toggle-button {
  background-color: #ccc;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}

.toggle-button.active {
  background-color: green;
}
.yellow-border {
  border: 2px solid yellow;
}
.picker {
  width: 100%;
  min-width: 400px;
  height: 40px;
  border-color: #f2f0f0;
  border-width: 2px;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 6px 5px;
  border-style: solid;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/master/calendar.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,OAAO;EACP,MAAM;EACN,UAAU;EACV,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA,gCAAgC;AAChC;EACE,eAAe,EAAE,mCAAmC;EACpD,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,MAAM;EACN,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".custom-box {\n  width: 40px;\n  padding: 20px;\n  border: 1px solid #ccc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: sticky;\n  left: 0;\n  z-index: 900;\n}\n.switch-row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n}\n.sticky-container {\n  display: flex;\n  position: sticky;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  background-color: #fff;\n  /* Add any additional styling you need here */\n}\n\n/* Styles for the month number */\n.month-number {\n  font-size: 20px; /* Adjust the font size as needed */\n  font-weight: bold;\n}\n\n.week-table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.week-table th,\n.week-table td {\n  border: 1px solid #ccc;\n  padding: 4px;\n  text-align: center;\n  min-width: 110px;\n}\n.week-table th {\n  background-color: #f0f0f0;\n  font-weight: bold;\n  width: 110px;\n  height: 10px;\n}\n\n.day-header {\n  font-size: 16px;\n}\n\n.time-column {\n  font-size: 16px;\n  position: sticky;\n  left: 82px;\n  border: 1px solid #ccc;\n  top: 0;\n  background-color: white;\n  z-index: 1;\n}\n\n/* .cell {\n  background-color: #ffffff;\n} */\n\n.add-event-cell {\n  text-align: center;\n}\n\n.add-event-button button {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.add-event-button button:hover {\n  background-color: #45a049;\n}\n\n.custom-modal {\n  width: 60%;\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.modal-content {\n  padding: 20px;\n}\n\n.toggle-button {\n  background-color: #ccc;\n  border: none;\n  color: white;\n  padding: 10px 20px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.toggle-button.active {\n  background-color: green;\n}\n.yellow-border {\n  border: 2px solid yellow;\n}\n.picker {\n  width: 100%;\n  min-width: 400px;\n  height: 40px;\n  border-color: #f2f0f0;\n  border-width: 2px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  padding: 6px 5px;\n  border-style: solid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
